// src/components/HighchartsSalesReport.jsx
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PropTypes from "prop-types";

const HighchartsSalesReport = ({
  chartOptions,
  chartData,
  formatSales,
  storess,
  selectedDate,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
          <h3>Date: {selectedDate}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Month</th>
              <th className="ms-5">Sales</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${label}`}>
                <td>{label}</td>
                <td>{formatSales(chartData.datasets[0].data[index])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

HighchartsSalesReport.propTypes = {
  chartOptions: PropTypes.object.isRequired,
  chartData: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({ data: PropTypes.arrayOf(PropTypes.number).isRequired })
    ).isRequired,
  }).isRequired,
  formatSales: PropTypes.func.isRequired,
  storess: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
  chartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  containerId: PropTypes.string.isRequired,
};

export default HighchartsSalesReport;
